var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "../classes/BaseService";
import { SourceAdapterContext } from "./SourceAdapterContext";
export class SourceService extends BaseService {
    constructor(framework) {
        super({
            initialState: {},
        });
        this.framework = framework;
        this.context = new SourceAdapterContext(this, framework);
    }
    init(adapter) {
        return __awaiter(this, void 0, void 0, function* () {
            this.adapter = adapter;
            this.initAdapter(adapter, this.context);
        });
    }
    _getSync(id) {
        return this.framework.state.select((state) => state.sources.all.find((s) => s.id === id));
    }
    getCurrent() {
        return this.framework.state.select((state) => state.sources.current);
    }
    getChildren(source) {
        return this.framework.state.select((state) => state.sources.all.filter((s) => s.parent === source.id));
    }
    getDescendents(rootSource) {
        const descendentsIds = this._getDescendentsIds(rootSource);
        return this.getAll().filter((source) => descendentsIds.includes(source.id));
    }
    _getDescendentsIds(rootSource) {
        let all = this.getAll()
            .filter((source) => source.parent && source.id !== rootSource.id)
            .map((source) => [source.id, source.parent]);
        const descendents = [];
        let added = [rootSource.id];
        let lastAdded = [];
        while (true) {
            lastAdded = added;
            added = [];
            for (const addedSourceId of lastAdded) {
                for (const [id, parent] of all) {
                    if (parent === addedSourceId) {
                        added.push(id);
                    }
                }
            }
            if (added.length > 0) {
                descendents.push(...added);
                all = all.filter(([id]) => !added.includes(id));
            }
            else {
                break;
            }
        }
        return descendents;
    }
    getAll() {
        return this.framework.state.select((state) => state.sources.all);
    }
    setCurrent(id) {
        this.framework.state.update((draft) => {
            draft.sources.current = draft.sources.all.find((source) => source.id === id);
        });
        this.notifySubscribers();
    }
}
//# sourceMappingURL=SourceService.js.map